import { render, staticRenderFns } from "./product_area.vue?vue&type=template&id=a49929f4&scoped=true"
import script from "./product_area.vue?vue&type=script&lang=js"
export * from "./product_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49929f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a49929f4')) {
      api.createRecord('a49929f4', component.options)
    } else {
      api.reload('a49929f4', component.options)
    }
    module.hot.accept("./product_area.vue?vue&type=template&id=a49929f4&scoped=true", function () {
      api.rerender('a49929f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/rebate/rebate_policy/form/components/product_area.vue"
export default component.exports